module.exports = __webpack_public_path__ + "static/surfer-d743fc557ab6009361446669c0d94dfb.jpg";